export const optionsAliases = {
  'account/verification' : 'account'
};